<template>
    <div>
        <v-card dark class="pa-4 grey darken-3 ma-4">
            <v-toolbar dark flat dense class="grey darken-3">
                <v-toolbar-title>Картка Історії пакетного продажу Подарункових Сертифікатів</v-toolbar-title>
            </v-toolbar>
    
            <v-card-text>
                <v-flex xs4 lg1>
                    <v-text-field v-model="soldData.sell_date" label="Дата" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.fio" label="ПІБ" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.phone" label="Телефон" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.contractor" label="Контрагент" readonly></v-text-field>
                </v-flex>
                <v-subheader>Продано Подарункових Сертифікатів</v-subheader>
                <v-flex xs12 lg6>
                    <v-simple-table dark>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Пакет
                                    </th>
                                    <th class="text-left">
                                        Кількість
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in soldList" :key="item.name">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.sold_out }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-flex>
                <v-subheader>Документи Тайфун</v-subheader>
                <v-flex xs12 lg6>
                    <v-simple-table dark>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Документ
                                    </th>
                                    <th class="text-left">
                                        Користувач
                                    </th>

                                    <th class="text-left">
                                        Коментар
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in soldDocumentsList" :key="item.name">
                                    <td>{{ item.typhoon_id }}</td>
                                    <td>{{ item.user }}</td>
                                    <td v-html="item.comment && item.comment.replace(/\n/g, '<br>')"></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="grey" @click="goBack()">
                    <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                </v-btn>
                <v-btn small text v-if="soldData.id" @click="exportData(soldData.reserved_token)" class="megogo--text">
                    Експорт продажів <v-icon class="pl-3">mdi-export</v-icon>
                </v-btn>
    
            </v-card-actions>
        </v-card>
    </div>
    </template>
    
    <script>
    import {
        ValidationObserver,
        ValidationProvider
    } from "vee-validate"
    
    import {
        mapActions
    } from 'vuex'
    
    import {
        mask
    } from "vue-the-mask"
    
    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        directives: {
            mask
        },
        data() {
            return {
                f: {},
                usersTable: false,
                search: '',
                footerProps: {
                    'items-per-page-options': [10, 20],
                    'items-per-page-text': 'на стор.'
                },

            }
        },
        methods: {
            ...mapActions(['setSnackbar', 'touch', 'getUsersList', 'getEgiftsSoldList', 'getEgiftsSoldDocumentsList', 'getEgiftsSoldData', 'getEgiftsStatExport', 'createXlsx', 'sendEgiftsToTyphoon']),
            goBack() {
                window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
            },
            getUsers() {
                this.usersTable = true
                this.getDataFromApi()
            },
            getDataFromApi() {
                this.getUsersList()
            },
            exportData(reserved_token) {
                this.getEgiftsStatExport({
                        status: [2],
                        dateTo: this.exportTo,
                        dateFrom: this.exportFrom,
                        reserved_token
                    })
                    .then(data => {
                        this.createXlsx(data)
                            .then(
                                () => {
                                    this.openExport = false
                                    window.open(process.env.NODE_ENV === 'production' ? '/api/xlsx/file/Report.xlsx' : 'http://dev.extraservices.com.ua:3003/api/xlsx/file/Report.xlsx')
                                }
                            )
                    })
                    .catch(error => this.setSnackbar(['error', error]))
            },
            sendToTyphoon() {
                this.sendEgiftsToTyphoon({
                    contractor_id: this.soldData.contractor_id,
                    id: this.soldData.id,
                    reserved_token: this.soldData.reserved_token
                })
                .then(data => {
                    if(data.error){
                        this.setSnackbar(['error', data.error])
                    }
                    if(data.doc_id){
                        this.setSnackbar(['info', 'Документ Тайфун створено'])
                        this.getEgiftsSoldData(this.$route.params.id)
                    }
                })
                .catch(error => console.log(error))
            }
        },
        async created() {
            await this.getEgiftsSoldData(this.$route.params.id)
            await this.getEgiftsSoldList(this.soldData.reserved_token)
            await this.getEgiftsSoldDocumentsList(this.soldData.reserved_token)
        },
        computed: {
            list() {
                return this.$store.state.adminpanel.usersList
            },
            soldList() {
                return this.$store.state.adminpanel.egiftsSoldList
            },
            soldData() {
                return this.$store.state.adminpanel.egiftsSoldData
            },
            soldDocumentsList() {
                return this.$store.state.adminpanel.egiftsSoldDocumentsList
            }
    
        },
        watch: {}
    }
    </script>
    
    <style>
    .inp-cnt {
        color: black;
        margin-left: 3px;
        margin-right: 3px;
        border: 1px solid rgb(7, 0, 0);
        width: 40px;
        text-align: center;
        padding: 1px;
        border-radius: 4px;
        box-sizing: border-box;
        background: #ffffff;
    }
    </style>
    